<template>
  <GmapMap
          :center="position"
          :zoom="15"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUI: false
          }"
          style="width: 100%; height: 400px"
  >
    <GmapMarker
            :position="position"
            :clickable="false"
    />
  </GmapMap>
</template>

<script>
  export default {
    name: "Map",
    data: () => ({
      position: {lat: 53.21911, lng: 6.57358}
    })
  }
</script>

<style scoped>
</style>
